import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71e8f005"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document bg-white relative overflow-y-scroll" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing sticky top-0 bg-white z-20" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-primary-600 font-bold" }, "Indietro", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-row pt-6 pb-6 sticky top-0 bg-white" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "font-bold block text-left pb-4" }, "Gestione Tag")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "street items-center flex" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-bold text-left subtitle" }, "Tutti i tag creati")
], -1))
const _hoisted_7 = { class: "searchbar flex" }
const _hoisted_8 = { class: "tag-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftArrow = _resolveComponent("LeftArrow")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_WorkingSiteTagCard = _resolveComponent("WorkingSiteTagCard")!
  const _component_Loader = _resolveComponent("Loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "header sticky top-0 bg-white w-full fixed relative inline-flex cursor-pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _createVNode(_component_LeftArrow, { class: "back-arrow" }),
            _hoisted_4
          ]),
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "text px-4 py-3 flex-grow",
              type: "text",
              placeholder: "Scrivi qui il nome del tag",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
              onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.tag()), ["enter"]))
            }, null, 544), [
              [_vModelText, _ctx.name]
            ]),
            _createVNode(_component_PrimaryButton, {
              class: "button bg-white text-primary flex-none",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onAddTag()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Aggiungi")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
              return (_openBlock(), _createBlock(_component_WorkingSiteTagCard, { "model-value": tag }, null, 8, ["model-value"]))
            }), 256))
          ])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loader, {
          key: 0,
          message: "Salvataggio..."
        }))
      : _createCommentVNode("", true)
  ], 64))
}